import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  async submit(event) {
    event.preventDefault()
    const form = event.target
    const formData = new FormData(form)
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
    
    try {
      const response = await fetch(form.action, {
        method: "POST",
        body: formData,
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          "Accept": "text/vnd.turbo-stream.html, application/json",
          "X-CSRF-Token": csrfToken
        }
      })

      const contentType = response.headers.get("content-type")
      
      if (contentType && contentType.includes("turbo-stream")) {
        // Turbo Stream response - will be handled automatically
        const text = await response.text()
        if (response.ok) {
          // Apply turbo stream updates
          Turbo.renderStreamMessage(text)
          form.reset()
          // Open payment modal
          const modal = document.querySelector('[data-controller="payment-modal"]')
          if (modal) {
            const controller = this.application.getControllerForElementAndIdentifier(modal, 'payment-modal')
            if (controller) {
              controller.open()
            }
          }
          // Пересортировать категории (сначала с участниками)
          this.resortCategories()
          
          // Scroll to requests section
          setTimeout(() => {
            document.getElementById('requests')?.scrollIntoView({ behavior: 'smooth' })
          }, 300)
        }
      } else {
        // JSON response (for errors)
        const data = await response.json()
        if (!response.ok) {
          this.showNotification(data.message, "error")
        }
      }
    } catch (error) {
      console.error('Form submission error:', error)
      this.showNotification("Произошла ошибка при отправке", "error")
    }
  }

  showNotification(message, type) {
    const notification = document.createElement("div")
    
    const bgColor = type === "success" ? "#10b981" : "#ef4444"
    notification.style.cssText = `
      position: fixed;
      top: 2rem;
      right: 2rem;
      padding: 1rem 1.5rem;
      background-color: ${bgColor};
      color: white;
      border-radius: 0.5rem;
      box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
      z-index: 9999;
      font-size: 16px;
      font-weight: 500;
      transition: opacity 0.3s, transform 0.3s;
    `
    notification.textContent = message

    document.body.appendChild(notification)

    setTimeout(() => {
      notification.style.opacity = '0'
      notification.style.transform = 'translateX(1rem)'
    }, 3000)

    setTimeout(() => {
      notification.remove()
    }, 3500)
  }

  resortCategories() {
    // Небольшая задержка, чтобы Turbo Stream обновил DOM
    setTimeout(() => {
      const container = document.querySelector('#requests .max-w-7xl')
      if (!container) return

      // Получаем все блоки категорий (исключая empty-message)
      const categoryBlocks = Array.from(container.children).filter(child => {
        return child.classList.contains('w-full') && 
               child.classList.contains('md:w-10/12') &&
               child.id !== 'empty-requests-message'
      })
      
      if (categoryBlocks.length === 0) return
      
      // Сортируем: сначала с участниками (по убыванию), затем пустые
      categoryBlocks.sort((a, b) => {
        const countA = parseInt(a.querySelector('[id$="-count"]')?.textContent?.trim() || '0')
        const countB = parseInt(b.querySelector('[id$="-count"]')?.textContent?.trim() || '0')
        return countB - countA
      })
      
      // Удаляем все блоки категорий из контейнера
      categoryBlocks.forEach(block => block.remove())
      
      // Добавляем их обратно в отсортированном порядке (в начало)
      const emptyMessage = container.querySelector('#empty-requests-message')
      categoryBlocks.forEach(block => {
        if (emptyMessage) {
          container.insertBefore(block, emptyMessage)
        } else {
          container.appendChild(block)
        }
      })
    }, 100)
  }
}
